import gql from 'graphql-tag';

export const DELETE_AFTERMARKET_DOCUMENT = gql`
  mutation DeactivateDocument($id: ID!) {
    deactivateDocument(id: $id)
  }
`;
